// Base
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
// Styles
import styles from "./HeroFeature.scss";

export default function HeroFeature(props) {
  const { value, suffix, responsive } = props;

  return (
    <div className={styles.hero_feature}>
      <span
        className={cx(styles.hero_feature__value, {
          [styles["hero_feature__value--responsive"]]: responsive,
        })}
      >
        {value}
      </span>
      <span
        className={cx(styles.hero_feature__suffix, {
          [styles["hero_feature__suffix--responsive"]]: responsive,
        })}
      >
        {suffix}
      </span>
    </div>
  );
}

// Props
HeroFeature.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  suffix: PropTypes.string,
  responsive: PropTypes.bool,
};

HeroFeature.defaultProps = {
  suffix: "",
  responsive: false,
};

HeroFeature.displayName = "HeroFeature";
